import localBusinessSchema from "./Schemas/localBusinessSchema";
import servicesSchema from "./Schemas/servicesSchema";
import contactSchema from "./Schemas/contactSchema";
import faqSchema from "./Schemas/faqSchema";
import jobPostingSchema from "./Schemas/jobPostingSchema";
import breadcrumbSchema from "./Schemas/breadcrumbSchema";

export default function getSchemasByRoute(pathname) {
    const schemas = [
        localBusinessSchema(),        // ✅ includes AggregateRating
        breadcrumbSchema(pathname)    // ✅ dynamic breadcrumb
    ];

    switch (pathname) {
        case "/":
            schemas.push(servicesSchema());
            break;

        case "/services":
            schemas.push(servicesSchema());
            break;

        case "/contact":
            schemas.push(contactSchema());
            break;

        case "/faq":
            schemas.push(faqSchema());
            break;

        case "/careers":
            schemas.push(jobPostingSchema());
            break;

        default:
            break;
    }

    return schemas;
}
